import { API, Auth, PubSub } from 'aws-amplify';
import { Logger } from '../../app/helpers/logger';
import { MESSAGE_TYPES, CONFIG_TYPES } from '../constants';
import { setToken } from './config';
import { MemoryStorage } from './memory-storage';

export const addLeadForwardSlash = string => {
  if (string[0] !== '/') {
    return `/${string}`;
  }
  return string;
};

export const handleConfig = ({ sendReply, message }) => {
  const { metadata } = message;
  const configHandlers = {
    [CONFIG_TYPES.USER_AGENT]: configValue => {
      window.navigator.userAgent = configValue;
    },
    [CONFIG_TYPES.AWS_WORKER_STORAGE]: configValue => {
      configValue.forEach(([key, value]) => {
        MemoryStorage.setItem(key, value);
      });
    }
  };

  try {
    for (const key in configHandlers) {
      const callback = configHandlers[key];
      if (key in message.payload) {
        callback(message.payload[key]);
      } else {
        const errorMsg = `worker:configuration key ${key} missing`;
        Logger.error(errorMsg);
        throw new Error(errorMsg);
      }
    }
    sendReply({ type: MESSAGE_TYPES.CONFIGURE_SUCCESS, metadata });
  } catch (error) {
    sendReply({ type: MESSAGE_TYPES.CONFIGURE_ERROR, payload: error, metadata });
  }
};

export const handleLogout = async ({ sendReply, message }) => {
  const { metadata } = message;
  try {
    await Auth.signOut();
    sendReply({ type: MESSAGE_TYPES.LOGOUT_SUCCESS, metadata });
  } catch (e) {
    sendReply({ type: MESSAGE_TYPES.LOGOUT_ERROR, payload: e, metadata });
  }
};
export const handleLogin = async ({ sendReply, message }) => {
  const {
    payload: { transicsUserProfileToken, authData, user },
    metadata
  } = message;
  if (!transicsUserProfileToken) {
    const errorMsg = 'worker:handleAuth missing transicsUserProfileToken';
    Logger.error(errorMsg);
    throw new Error(errorMsg);
  } else {
    setToken(transicsUserProfileToken);
  }

  try {
    const response = await Auth.federatedSignIn('developer', authData, user);
    Logger.debug('worker:handleAuth ', response);
    sendReply({ type: MESSAGE_TYPES.LOGIN_SUCCESS, payload: response, metadata });
  } catch (error) {
    Logger.error('worker:handleAuth ', error);
    sendReply({ type: MESSAGE_TYPES.LOGIN_ERROR, payload: error, metadata });
  }
};

export const handleTopicSubscribe = ({ sendReply, message }) => {
  const { payload: topic, metadata } = message;

  try {
    PubSub.subscribe(topic, {}).subscribe({
      next: data => {
        sendReply({ type: MESSAGE_TYPES.TOPIC_RESPONSE, payload: data.value, metadata });
      },
      error: error => {
        sendReply({ type: MESSAGE_TYPES.TOPIC_ERROR, payload: error, metadata });
      }
    });
  } catch (error) {
    sendReply({ type: MESSAGE_TYPES.TOPIC_ERROR, payload: error, metadata });
  }
};
export const handleCurrentAuthenticatedUser = async ({ sendReply, message }) => {
  const {
    metadata,
    payload: { token }
  } = message;
  try {
    setToken(token);
    const response = await Auth.currentAuthenticatedUser();
    sendReply({ type: MESSAGE_TYPES.CURRENT_AUTHENTICATED_USER_SUCCESS, payload: response, metadata });
  } catch (error) {
    sendReply({ type: MESSAGE_TYPES.CURRENT_AUTHENTICATED_USER_ERROR, payload: error, metadata });
  }
};

export const handleApi = async ({ sendReply, message }) => {
  const {
    payload: { api, endpoint, method, ...rest },
    metadata
  } = message;

  if (!method) {
    throw new Error('missing method');
  }

  // webpack during the build was dropping our some of the dynamic imports from the aws library
  // they had to be defined here to be included in the build
  let func = (...args) => API.get(...args);
  switch (method) {
    case 'post':
      func = (...args) => API.post(...args);
      break;
    case 'put':
      func = (...args) => API.put(...args);
      break;
  }

  try {
    const response = await func(api, addLeadForwardSlash(endpoint), { ...rest });
    sendReply({
      type: MESSAGE_TYPES.API_SUCCESS,
      payload: response,
      metadata
    });
  } catch (error) {
    sendReply({
      type: MESSAGE_TYPES.API_ERROR,
      payload: error,
      metadata
    });
  }
};

export const messageResponseHandler = ({ message, sendReply }) => {
  switch (message.type) {
    case MESSAGE_TYPES.CONFIGURE:
      handleConfig({ message, sendReply });
      break;
    case MESSAGE_TYPES.LOGIN_REQUEST:
      handleLogin({ message, sendReply });
      break;
    case MESSAGE_TYPES.LOGOUT_REQUEST:
      handleLogout({ message, sendReply });
      break;
    case MESSAGE_TYPES.TOPIC_SUBSCRIBE:
      handleTopicSubscribe({ message, sendReply });
      break;
    case MESSAGE_TYPES.CURRENT_AUTHENTICATED_USER:
      handleCurrentAuthenticatedUser({ message, sendReply });
      break;
    case MESSAGE_TYPES.API_REQUEST:
      handleApi({ message, sendReply });
      break;
  }
};
